<template>
  <div>
    <datalist id="towns-list">
      <option v-for="town in towns.keys()"> {{ town }}</option>
    </datalist>
    <datalist id="nations-list">
      <option v-for="nation in nations.keys()"> {{ nation.toUpperCase() }}</option>
    </datalist>
    <BarcodeScanner style="display: flex; justify-content: center; margin-bottom: 48px"
                    v-if="isBarcodeScannerEnabled" v-on:barcode-read="barcodeRead"></BarcodeScanner>
    <b-form ref="customerIdentificationForm">
      <b-form-row>
        <b-form-group label="Codice Tessera" class="col-md-4">
          <b-input-group>
            <b-input-group-prepend>
              <b-button variant="dark" @click="toggleBarcodeScanner()">
                <b-icon-upc-scan></b-icon-upc-scan>
              </b-button>
            </b-input-group-prepend>
            <b-form-input
              autocomplete="off"
              id="barcode"
              name="Codice Tessera"
              v-model="detail.barcode"
              v-validate="{ required: true, min: 13, max: 13, regex: /^0229|0206/}"
              :state="stateValidation('Codice Tessera')"
              aria-describedby="input-barcode-feedback"
              @input="searchCustomer"
            />
            <b-input-group-append>
              <b-button id="clear-barcode" class="fix-radius" @click="detail.barcode = ''; resetFields(true)"
                        variant="secondary" v-b-tooltip.hover title="Pulisci Codice Tessera">
                <b-icon-x-circle></b-icon-x-circle>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-barcode-feedback">{{
                veeErrors.first('Codice Tessera')
              }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <hr>
      <b-form-row>
        <b-form-group label="Cognome" class="col-md-6">
          <b-form-input
            autocomplete="off"
            id="last-name"
            v-model="detail.lastName"
            name="Cognome"
            v-validate="{ required: true}"
            :state="stateValidation('Cognome')"
            aria-describedby="input-lastname-feedback"
          />
          <b-form-invalid-feedback id="input-lastname-feedback">{{
              veeErrors.first('Cognome')
            }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Nome" class="col-md-6">
          <b-form-input
            autocomplete="off"
            id="first-name"
            v-model="detail.firstName"
            name="Nome"
            v-validate="{ required: true}"
            :state="stateValidation('Nome')"
            aria-describedby="input-name-feedback"
          />
          <b-form-invalid-feedback id="input-name-feedback">{{
              veeErrors.first('Nome')
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form-row>
      <hr>
      <b-form-row>
        <b-form-group class="col-md-12">
          <h4>Nascita</h4>
          <b-form-row>
            <b-form-group label="Data di nascita" class="col-md-3">
              <DatePicker ref="birthDate" id="birth-date" description="Data di nascita" v-model="detail.birthDate"
                          :required="true" :not-after-today="true"/>
            </b-form-group>
            <b-form-group label="Genere" class="col-md-2">
              <b-form-select
                id="sex"
                v-model="detail.sex"
                :options="genders()"
                name="Genere"
                v-validate="{ required: true }"
                :state="stateValidation('Genere')"
                aria-describedby="input-gender-feedback"/>
              <b-form-invalid-feedback id="input-gender-feedback">
                {{ veeErrors.first('Genere') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>
          <b-form-row>
            <b-form-group class="col-md-12">
              <b-card no-body>
                <b-tabs v-model="birthPlaceTab" pills card vertical @activate-tab="switchNationality">
                  <b-tab id="italian-birth-place" title="Italiano" active>
                    <b-card-text>
                      <b-form-row>
                        <b-form-group label="Luogo di nascita" class="col-md-6">
                          <b-form-input
                            autocomplete="off"
                            id="it-birth-place-city"
                            v-on:input="handleSearchInput"
                            v-on:blur="validateBirthPlaceCity()"
                            v-model="detail.birthPlaceCity"
                            name="Luogo di nascita"
                            :state="stateValidation('Luogo di nascita')"
                            aria-describedby="input-birthplace-feedback"
                          />

                          <div style="position: relative">
                            <div v-if="filteredList.length > 0 && isBirthPlaceSearchActive" class="suggestions-list">
                              <div
                                v-for="(item, index) in filteredList"
                                :key="index"
                                class="suggestion-item"
                                @click="handleBirthPlaceSelection(item)"
                              >
                                {{ item.name }} - {{ item.provinceCode }}
                              </div>
                            </div>
                          </div>
                          <b-form-invalid-feedback id="input-birthplace-feedback">
                            {{ veeErrors.first('Luogo di nascita') }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group label="Provincia di nascita" class="col-md-6">
                          <b-form-input
                            readonly
                            v-model="detail.birthPlaceProvince"
                            name="Provincia di Nascita"
                            :state="stateValidation('Provincia di Nascita')"
                            aria-describedby="input-birthplace-feedback"
                          />
                          <b-form-invalid-feedback id="input-birthplace-feedback">
                            {{ veeErrors.first('Provincia di Nascita') }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-form-row>
                    </b-card-text>
                  </b-tab>
                  <b-tab id="foreign-birth-place" title="Straniero">
                    <b-card-text>
                      <b-form-row>
                        <b-form-group label="Nazione di nascita" class="col-md-6">
                          <b-form-input
                            autocomplete="off"
                            id="birth-place-nation"
                            list="nations-list"
                            v-model="detail.birthPlaceNation"
                            name="Nazione di nascita"
                            v-validate="validateNation()"
                            :state="stateValidation('Nazione di nascita')"
                            aria-describedby="input-birthplace-nation-feedback"

D                    v-if="birthPlaceTab === FOREIGN_BIRTH_DATE_TAB"/>
                  <b-form-invalid-feedback id="input-birthplace-nation-feedback">
                    {{ veeErrors.first('Nazione di nascita') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Città di nascita" class="col-md-6">
                  <b-form-input
                    autocomplete="off"
                    id="ee-birth-place-city"
                    v-model="detail.birthPlaceCity"
                    name="Città di nascita"
                    :state="stateValidation('Città di nascita')"
                    aria-describedby="input-birthplace-city-feedback"
                    v-if="birthPlaceTab === FOREIGN_BIRTH_DATE_TAB"/>
                  <b-form-invalid-feedback id="input-birthplace-city-feedback">
                    {{ veeErrors.first('Città di nascita') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-form-row>
            </b-card-text>
          </b-tab>
          </b-tabs>
          </b-card>
        </b-form-group>
      </b-form-row>
      </b-form-group>
      </b-form-row>

      <b-row align-h="end" class="mr-2">
        <b-button @click="switchTab" id="fill-identification-button" variant="primary">Conferma</b-button>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import BarcodeScanner from "@/components/digitalization/BarcodeScanner";
import DatePicker from "@/components/DatePicker";
import eventBus from "@/EventBus";
import genders from "@/Genders";
import CustomersApi from "@/api/CustomersApi";

export default {
  name: "CustomerIdentificationData",
  components: {DatePicker, BarcodeScanner},
  props: ['nations', 'towns'],
  provide() {
    return {parentValidator: this.$validator}
  },
  created() {
    eventBus.$on('reset-state', (resetBarcode) => {
      if (resetBarcode) {
        console.log("Dentro if")
        this.detail = {}
      } else {
        console.log("Dentro else")
        this.detail = {
          barcode: this.detail.barcode
        }
      }
      this.foundCustomer = false
      this.$refs['birthDate'].reset()
      this.$validator.reset();
    })
  },
  data: () => ({
    birthPlaceSearch: '',
    isBirthPlaceSearchActive: false,
    isBarcodeScannerEnabled: false,
    birthPlaceCityRequired: true,
    birthPlaceTab: 0,
    foundCustomer: false,
    ITALIAN_BIRTH_DATE_TAB: 0,
    FOREIGN_BIRTH_DATE_TAB: 1,
    detail: {
      birthPlaceNation: 'ITALIA',
    }
  }),
  computed: {
    filteredList() {
      return this.towns.filter(item => {
        const search = this.birthPlaceSearch.toLowerCase()
        return (
          item.name.toLowerCase().includes(search)
        )
      })
    }
  },
  methods: {
    handleSearchInput(value) {
      this.birthPlaceSearch = value
      console.log("Testo cambiato Customer Identification")
      this.isBirthPlaceSearchActive = true
    },
    handleBirthPlaceSelection(value) {
      this.detail.birthPlaceCity = value.name;
      this.fillBirthPlaceProvince(value.provinceCode);
      this.isBirthPlaceSearchActive = false
    },
    switchTab() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.foundCustomer === false) this.getCustomer().then(customers => this.formatCustomer(customers))

          if (this.isNotItaly(this.detail.birthPlaceNation)) {
            this.detail.birthPlaceProvince = this.nations.get(this.detail.birthPlaceNation).codeIsoAlpha3
          }

          eventBus.$emit("identification-data-filled", this.detail)
          eventBus.$emit("switch-tab", 1)
        }
      })
    },
    isNotItaly(nation) {
      return nation && nation.toUpperCase() !== 'ITALIA'
    },
    genders: () => genders,
    toggleBarcodeScanner() {
      this.isBarcodeScannerEnabled = !this.isBarcodeScannerEnabled
    },
    barcodeRead(event) {
      this.isBarcodeScannerEnabled = false
      this.detail.barcode = event.barcode
    },
    fillBirthPlaceProvince(code) {
      this.detail.birthPlaceProvince = code
    },
    getCustomer() {
      let birthPlace = (this.detail.birthPlaceNation == null || this.detail.birthPlaceNation.toUpperCase() === 'ITALIA')
        ? this.detail.birthPlaceCity
        : this.detail.birthPlaceNation

      let customerData = this.detail
      let filters = {
        firstName: customerData.firstName,
        lastName: customerData.lastName,
        sex: customerData.sex,
        birthDate: customerData.birthDate,
        birthPlace: birthPlace.toUpperCase()
      }

      return CustomersApi.findCustomerBy(filters)
    },
    searchCustomer(barcode) {
      if (barcode.length === 13) {
        CustomersApi.findCustomerBy({barcode})
          .then(customers => {
            if (customers.length > 0) {
              this.foundCustomer = true
              let customer = customers[0]

              this.formatCustomer(customers)

              this.detail.firstName = customer.firstName
              this.detail.lastName = customer.lastName
              this.detail.birthDate = customer.birthDate
              this.detail.sex = customer.gender.substring(0, 1)

              const birthPlaceNation = customer.birthPlace.nation
              this.birthPlaceTab = birthPlaceNation === null || birthPlaceNation.toUpperCase() === 'ITALIA' ? this.ITALIAN_BIRTH_DATE_TAB : this.FOREIGN_BIRTH_DATE_TAB

              this.$nextTick(() => {
                this.detail.birthPlaceCity = customer.birthPlace.city ? customer.birthPlace.city.toUpperCase() : null
                this.detail.birthPlaceProvince = customer.birthPlace.province ? customer.birthPlace.province.toUpperCase() : null
                this.detail.birthPlaceNation = customer.birthPlace.nation ? customer.birthPlace.nation.toUpperCase() : null
              })
            } else this.resetFields(false)

          })
      } else this.resetFields(false)
    },
    resetFields(resetBarcode) {
      eventBus.$emit("reset-fields", resetBarcode)
    },
    formatCustomer(customers) {
      let customer = null
      if (customers.length > 0) {
        customer = customers[0]

        if (this.detail.barcode !== customer.barcode) {
          customer = {
            ...customer,
            barcode: this.detail.barcode,
            oldBarcode: customer.barcode,
          }
        }
      }
      eventBus.$emit("customer-found", customer)
    },
    switchNationality(newIndex) {
      switch (newIndex) {
        case this.ITALIAN_BIRTH_DATE_TAB:
          this.birthPlaceCityRequired = true
          this.detail.birthPlaceCity = null
          this.detail.birthPlaceProvince = null
          this.detail.birthPlaceNation = 'ITALIA'
          break;
        case this.FOREIGN_BIRTH_DATE_TAB:
          this.birthPlaceCityRequired = false
          this.detail.birthPlaceCity = null
          this.detail.birthPlaceProvince = 'EE'
          this.detail.birthPlaceNation = null
          break;
      }
    },
    validateNation() {
      let validNations = Array.from(this.nations.keys())
      let validNationsRegex = validNations.map(nation => nation.toUpperCase()).join('|')
      return {required: true, regex: validNationsRegex}
    },
    valideTown() {
      let validTowns = Array.from(this.towns.keys())
      let validTownsRegex = validTowns.map(town => town.toUpperCase()).join('|')
      if (this.detail.birthPlaceNation === 'ITALIA') {
        return {required: this.birthPlaceCityRequired, regex: validTownsRegex}
      } else {
        return {require: false}
      }
    },
    validateBirthPlaceCity() {
      if (!this.towns.filter(town => town.name === this.detail.birthPlaceCity)) {
        this.detail.birthPlaceCity = ''
      }
    },
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref)
      } else {
        return null
      }
    },
  }
}
</script>

<style scoped>
#clear-barcode.fix-radius {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

.suggestions-list {
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  z-index: 50;
}

.suggestion-item {
  padding: 8px;
  cursor: pointer;
  background: white;
}

.suggestion-item:hover {
  background-color: #f8f9fa;
}
</style>

